// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip-root-3a3xt","tooltip":"Tooltip-tooltip-3z3vF","title":"Tooltip-title-3CKN8"};